import { Tools } from '@/plugins/tools'
import { ethers } from 'ethers'
import redPackABI from '../abi/HappyRedPacket.json'
import { TokenContract } from './token'
import BN from 'bignumber.js'

// interface ICreateRedPackParams {
//   /* 红包数量 */
//   number: number
//   /* 标题 */
//   title: string
//   /* 币种合约地址 */
//   tokenContract: string
//   /* 币种类型 0 - ETH  1 - ERC20 */
//   tokenType: 0 | 1
//   /* 总金额 */
//   totalToken: string
// }

interface ICreateRedPackParams {
  quantity: number
}

export class RedPacketContract extends ethers.Contract {
  private _provider: ethers.providers.Web3Provider | ethers.providers.JsonRpcProvider
  private providerSigner: ethers.providers.JsonRpcSigner
  private contract: string

  constructor (_provider: ethers.providers.Web3Provider | ethers.providers.JsonRpcProvider, contract: string) {
    super(contract, redPackABI, _provider.getSigner())

    console.log(contract)

    this._provider = _provider
    this.providerSigner = _provider.getSigner()
    this.contract = contract
  }

  /**
   * 创建红包
   * @param params
   * @returns
   */
  async createRedPack (params: ICreateRedPackParams, decimal: number, quantity: number) {
    // const paramsData = [
    //   params.number,
    //   true,
    //   24 * 60 * 60,
    //   '',
    //   params.title,
    //   params.tokenType,
    //   params.tokenContract || `0x${'0'.repeat(40)}`,
    //   ethers.utils.parseUnits(params.totalToken, decimal)
    // ] as any[]

    const paramsData = [
      params.quantity
    ] as any[]

    // const value = ethers.utils.parseUnits(params.tokenContract ? '0' : params.totalToken, decimal)
    const value = '0'

    console.log(paramsData, value)

    const gasPrice = await this._provider.getGasPrice()

    const nonce = await this._provider.getTransactionCount(this.providerSigner.getAddress())

    const inter = new ethers.utils.Interface(redPackABI)

    const data = inter.encodeFunctionData('mint', paramsData)

    const txData = {
      to: this.contract,
      data,
      value
      // nonce,
      // gasPrice
    }

    console.log(txData)

    // const gasLimit = await this.providerSigner.estimateGas(txData)

    let gasLimit = await this.providerSigner.estimateGas(txData)

    const maxGas = Math.max(560000 * quantity, gasLimit.toNumber())

    console.log('gasLimit-top', maxGas, 560000 * quantity, gasLimit.toNumber())

    gasLimit = ethers.BigNumber.from(maxGas)

    console.log('gasLimit', gasLimit.toString())
    // const gasLimit = ethers.BigNumber.from(
    //   new BN(gas.toString()).multipliedBy('2').toString()
    // )

    // console.log('gasLimit', gasLimit.toNumber())

    paramsData.push({
      value,
      gasLimit: gasLimit
    })

    console.log('paramsData', paramsData)

    return this.mint(
      ...paramsData
    )
  }
}
